import { render, staticRenderFns } from "./BasicInfoField.vue?vue&type=template&id=72d760c8&"
import script from "./BasicInfoField.vue?vue&type=script&lang=ts&"
export * from "./BasicInfoField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports